export const INIT_CALCULATOR = 'INIT_CALCULATOR';
export const UPDATE_CALC_FIELD_VALUE = 'UPDATE_CALC_FIELD_VALUE';
export const CHANGE_COUNTRY_MENU = 'CHANGE_COUNTRY_MENU';

export const initCalculator = (data) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: INIT_CALCULATOR,
                data: data,
            }),
        );
    };
};
export const updateCalculatorFieldValue = (formName, fieldName, value) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CALC_FIELD_VALUE,
                formName,
                value,
                fieldName,
            }),
        );
    };
};
